import { fetchCountryCode } from '../../Redux/Slices/countrySlice';
import * as validateModule from './validateInput';

/**
 * Updates the COUNTRIES and COUNTRY_PHONE_LENGTHS in validateInput.js
 * with data from the API.
 * 
 * This function should be called after the country data is loaded from API
 * @param {Object} countryData - API response with country data
 */
export const updateValidateInputData = (countryData) => {
  if (!countryData || !countryData.data || !Array.isArray(countryData.data)) {
    console.warn('Country data is not valid, skipping update to validateInput');
    return;
  }

  try {
    // Create new country code to name map
    const newCountries = {};
    
    // Create new country code to phone length map
    const newPhoneLengths = {};

    // Populate the maps from API data
    countryData.data.forEach(country => {
      if (country.country_code && country.country_name) {
        newCountries[country.country_code] = country.country_name;
      }
      
      if (country.country_code && country.digit_length) {
        newPhoneLengths[country.country_code] = country.digit_length;
      }
    });

    // Only update if we have data
    if (Object.keys(newCountries).length > 0) {
      // Replace the data in validateInput.js
      // This works because in JavaScript, imported objects are references
      Object.keys(validateModule.COUNTRIES).forEach(key => {
        delete validateModule.COUNTRIES[key];
      });
      
      Object.entries(newCountries).forEach(([key, value]) => {
        validateModule.COUNTRIES[key] = value;
      });
    }

    if (Object.keys(newPhoneLengths).length > 0) {
      // Completely replace the phone lengths data
      Object.keys(validateModule.COUNTRY_PHONE_LENGTHS).forEach(key => {
        delete validateModule.COUNTRY_PHONE_LENGTHS[key];
      });
      
      Object.entries(newPhoneLengths).forEach(([key, value]) => {
        validateModule.COUNTRY_PHONE_LENGTHS[key] = value;
      });
    }

    console.log('Updated validateInput with API country data');
  } catch (error) {
    console.error('Failed to update validateInput with API data:', error);
  }
};

/**
 * Redux middleware to listen for country data fetch success
 * and update validateInput data
 */
export const countryDataMiddleware = store => next => action => {
  // Call next(action) first to ensure the action proceeds normally
  const result = next(action);
  
  // Check if this is the successful completion of fetchCountryCode
  if (action.type === fetchCountryCode.fulfilled.type && action.payload) {
    // Update the validation module data
    updateValidateInputData(action.payload);
  }
  
  return result;
};